import React from 'react';

const SingleItem = ({ data, index, paginateData, handleEnableDisabled, HandleOrderEditModalShow, handleDelete }) => {
    return (
        <>
            <tr>

                <td data-label="S.N.">
                    {index + 1}
                </td>

                <td data-label="Type">{data?.type}</td>
                <td data-label="Order #">{data?.orderNo}</td>
                <td data-label="Platform">{data?.platformTypeId?.name}</td>
                <td data-label="Manage Crypto">
                    <table className="table table-bordered table-sm mb-0">
                        <thead>
                            <tr>
                                <th>Name</th>
                                <th className="text-center">Quantity</th>
                                <th className="text-end">Price</th>
                            </tr>
                        </thead>
                        <tbody>
                            {data?.products?.map((item, index) => (
                                <tr key={item?._id || index}>
                                    <td>{item?.productId?.name}</td>
                                    <td>{item?.quantity}</td>
                                    <td>{item?.price}$</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </td>
                {/* <td data-label="Manage Crypto">{data?.network}</td> */}
                <td data-label="Order Amount">{data?.subtotal}$</td>
                <td data-label="Profit %">{data?.profit}%</td>
                <td data-label="Profit Amount">{data?.profitAmount}$</td>
                <td data-label="Total With Profit">{data?.totalWithProfit}$</td>


                <td data-label="Status">
                    {data?.status ? (
                        <span class="badge badge--success text-success">Enabled</span>
                    ) : (
                        <span>
                            <span class="badge badge--warning text-warning">Disabled</span>
                        </span>
                    )}
                </td>


                <td data-label="Action">
                    <button onClick={() => HandleOrderEditModalShow({ data, type: data?.type })} class="btn btn-sm btn-outline-primary"><i class="la la-pencil-alt"></i> Edit</button>
                    {data?.status ? (
                        <button
                            onClick={() => handleEnableDisabled(data?._id)}
                            class="btn btn-sm btn-outline-danger confirmationBtn"
                        >
                            <i class="la la-eye-slash"></i> Disable
                        </button>
                    ) : (
                        <button
                            onClick={() => handleEnableDisabled(data?._id)}
                            class="btn btn-sm btn-outline-success confirmationBtn"
                        >
                            <i class="la la-eye"></i> Enable
                        </button>
                    )}
                    <button class="btn btn-sm btn-outline-danger " onClick={() => handleDelete(data?._id)} ><i class="la la-trash"></i> Delete</button>
                </td>
            </tr>
        </>
    );
};

export default SingleItem;